import React from 'react';
import _ from 'lodash';
import { useMutation } from 'react-fetching-library';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Select,
  MenuItem,
  Tooltip,
  Rating,
  Grid,
  IconButton,
  Typography,
  Card,
  CardHeader,
  Stack,
  CircularProgress,
  Box,
  FormControl,
  InputLabel,
  FormHelperText,
  useMediaQuery,
  List,
  ListItem,
  ListItemText,
  Divider,
  Menu
} from '@mui/material';
import { DataGridPro, GridRow } from '@mui/x-data-grid-pro';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  employeeReviewsColumns
} from '../../../../../services/column-definitions';
import {
  submitEmployeeReviewRecord,
  deleteEmployeeReviewRecord
} from '../../../../../services/request';
import { useManager } from '../../../../../pages/Manager';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { formatDateTime } from '../../../../../services/functions';
import { functions } from '../../../../employee/applications/functions';


export default function Reviews() {
  const {
    period,
    managerEmployee: rowData,
    setManagerEmployee: setRowData,
    choices,
    managerEmployees,
    managerEmployee,
    setManagerEmployees
  } = useManager();
  const isMobile = useMediaQuery('(max-width:600px)');
  const { mutate, loading } = useMutation(submitEmployeeReviewRecord);
  const { mutate: deleteMutate } = useMutation(deleteEmployeeReviewRecord);
  const [confirmDeleteModal, setConfirmDeleteModal] = React.useState(false);
  const [addEditModal, setAddEditModal] = React.useState(false);
  const [activeData, setActiveData] = React.useState({});
  const [expandedRows, setExpandedRows] = React.useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuRow, setMenuRow] = React.useState(null);
  console.log('pid', period);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRow(null);
  };

  const handleOpenAddEditModal = rowData => {
    setActiveData(rowData);
    setAddEditModal(true);
  };

  const handleOpenDeleteModal = rowData => {
    setActiveData(rowData);
    setConfirmDeleteModal(true);
  };

  const handleCloseOpenAddEditModal = () => {
    setAddEditModal(false);
    setActiveData({});
  };

  // const handleSetActiveDocument = async (id, name, file_url) => {
  //   const { payload, error, loading } = await query(id);

  //   if (!error) {
  //     const url = window.URL.createObjectURL(payload);
  //     setActiveDocument({ uri: url, fileName: name, file_url });
  //   } else {
  //     toast.error('Nie udało się otworzyć załącznika');
  //   }
  // };

  const handleDelete = async id => {
    const { error } = await deleteMutate(id);
    if (!error) {
      setRowData(prev => ({
        ...prev,
        reviews: prev.reviews.filter(element => element.id !== id)
      }));
      setManagerEmployees(prevEmployees => prevEmployees.map(emp => emp.id === managerEmployee.id
        ? { ...emp, reviews: emp.reviews.filter(review => review.id !== id) } // Usuwamy review dla danego pracownika
        : emp
      ));
      toast.success('Opinia została usunięta');
    }

    if (error) {
      toast.error('Nie udało się usunąć opinii');
    }
    setActiveData({});
  };

  const handleSubmit = async values => {
    const id = activeData.id || null;
    const { payload, loading, error } = await mutate(id, values);
    if (!error && !loading) {
      setRowData(prev => ({
        ...prev,
        reviews: id
          ? prev.reviews.map(review => (review.id === id ? payload : review)) // Aktualizacja istniejącego elementu
          : [payload, ...prev.reviews] // Dodanie nowego elementu
      }));

      setManagerEmployees(prevEmployees => prevEmployees.map(emp => emp.id === managerEmployee.id
        ? { ...emp, reviews: id
          ? emp.reviews.map(review => (review.id === id ? payload : review)) // Aktualizacja istniejącego review
          : [payload, ...emp.reviews] } // Dodanie nowego review
        : emp));

      toast.success(`Rekord został ${id ? 'edytowany' : 'dodany'}`);
      handleCloseOpenAddEditModal();
      setActiveData({});
    }

    if (error) {
      toast.error(`Nie udało ${id ? 'edytować' : 'dodać'} rekordu`);
    }
  };

  const handleRowClick = id => {
    setExpandedRows(prev => ({
      [id]: !prev[id] // Przełączanie stanu rozwinięcia
    }));
  };

  const AccordionRow = props => {
    const isExpanded = expandedRows[props.row.id];

    return (
      <div>
        <GridRow {...props} onClick={() => handleRowClick(props.row.id)} />
        {isExpanded && (
          <div
            style={{
              padding: '24px',
              fontSize: '0.5rem',
              backgroundColor: '#f9f9f9'
            }}
          >
            {/* Siatka dla "grades" */}
            <Grid container spacing={2}>
              {props.row.grades.map(grade => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={grade.id} // Maksymalnie 6 elementów w rzędzie na dużych ekranach
                >
                  <Typography variant="subtitle1" ml={1}>
                    {grade.category_display}
                  </Typography>
                  <Rating
                    name="read-only"
                    value={grade.value}
                    max={6}
                    readOnly
                  />
                </Grid>
              ))}
            </Grid>
            {/* Siatka dla opisu */}
            <Grid container spacing={2} style={{ marginTop: '16px' }}>
              <Grid item xs={12} lg={4}>
                <Stack>
                  <Typography variant="h6">Umiejętności z zakresu programu</Typography>
                  <Typography>{props.row.programming_skills}</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} lg={4}>
                <Stack>
                  <Typography variant="h6">Predyspozycje wychowawcze</Typography>
                  <Typography>{props.row.educational_predispositions}</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} lg={4}>
                <Stack>
                  <Typography variant="h6">Specjalista (umiejętności i predyspozycje)</Typography>
                  <Typography>{props.row.special_skills}</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <Typography variant="h6">Dłuższy opis</Typography>
                  <Typography>{props.row.description}</Typography>
                </Stack>
              </Grid>
            </Grid>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <Card style={{ height: isMobile ? '70vh' : '100vh', border: '2px solid transparent', overflow: 'auto' }}>
        <CardHeader
          action={
            loading ? (
              <Box sx={{ p: '8px', height: '40px' }}>
                <CircularProgress size={24} />
              </Box>
            ) : (
              <Tooltip title="Dodaj">
                <IconButton
                  color="primary"
                  component="label"
                  onClick={() => setAddEditModal(true)}
                >
                  <AddCircleIcon />
                </IconButton>
              </Tooltip>
            )
          }
        />
        {isMobile ? (
          <Stack>
            <List>
              {rowData?.reviews.map(row => (
                <ListItem key={row.id} divider>
                  <ListItemText primary={<Typography><b>Ocena:</b> {row.final_grade}</Typography>} secondary={<Stack direction="column">
                    <Divider flexItem />
                    <Typography><b>Autor:</b> {row.author_name}</Typography>
                    <Typography><b>Stanowisko:</b> {row.function_type_display}</Typography>
                    <Typography><b>Aplikacja:</b> {row.application}</Typography>
                    <Typography><b>Impreza:</b> {row.event_display}</Typography>
                    <Typography><b>Ośrodek:</b> {row.resort_name}</Typography>
                    <Typography><b>Data dodania:</b> {formatDateTime(row.created_at)}</Typography>
                  </Stack>} />
                  <IconButton onClick={event => handleMenuOpen(event, row)}>
                    <MoreVertIcon />
                  </IconButton>
                </ListItem>
              ))}
            </List>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
              <MenuItem onClick={() => {
                handleOpenAddEditModal(menuRow);
                handleMenuClose();
              }}>
                <EditIcon style={{ marginRight: 8 }} color="primary" /> Edytuj
              </MenuItem>
              <MenuItem onClick={() => {
                handleOpenDeleteModal(menuRow);
                handleMenuClose();
              }}>
                <DeleteIcon style={{ marginRight: 8 }} color="error" /> Usuń
              </MenuItem>
            </Menu>
          </Stack>
        ) : <DataGridPro
          rows={rowData.reviews === undefined ? [] : rowData.reviews}
          columns={employeeReviewsColumns(
            handleOpenAddEditModal,
            handleOpenDeleteModal,
            true
          )}
          components={{
            Row: AccordionRow,
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                Brak wystawionych opinii
              </Stack>
            )
          }}
        />}
        <ConfirmDialog
          open={confirmDeleteModal}
          setOpen={setConfirmDeleteModal}
          onConfirm={() => handleDelete(activeData.id)}
        >
          <p>
            Czy na pewno chcesz usunąć opinię <b>{activeData?.value}</b>?
          </p>
        </ConfirmDialog>
      </Card>
      <FormModal
        open={addEditModal}
        onClose={handleCloseOpenAddEditModal}
        handleSubmit={handleSubmit}
        data={activeData}
      />
    </div>
  );
}

const FormModal = ({ open, onClose, handleSubmit, data }) => {
  const {
    managerEmployee: rowData,
    choices,
    application,
    weekPeriod
  } = useManager();

  const cleanedZsPeriod = Object.fromEntries(
    Object.entries(weekPeriod).filter(([key]) => ['start', 'end', 'nr', 'name'].includes(key))
  );
  const isEventOptional = [
    functions.INSTRUCTOR,
    functions.LIFEGUARD,
    functions.NURSE,
    functions.PHOTOGRAPHER
  ].includes(rowData.function_type);
  const olValidationSchema = Yup.object({
    employee: Yup.string().required('To pole nie może być puste'),
    application: Yup.string().required('To pole nie może być puste'),
    camp: Yup.string().required('To pole nie może być puste'),
    resort: Yup.string().required('To pole nie może być puste'),
    event: Yup.string().when([], {
      is: () => !isEventOptional,
      then: schema => schema.required('To pole nie może być puste'),
      otherwise: schema => schema.nullable().notRequired()
    }),

    periods_type: Yup.string().required('To pole nie może być puste'),
    programming_skills: Yup.string().required('To pole nie może być puste'),
    educational_predispositions: Yup.string().required('To pole nie może być puste'),
    special_skills: Yup.string().required('To pole nie może być puste'),
    description: Yup.string().required('To pole nie może być puste')
  });

  const zsValidationSchema = Yup.object({
    employee: Yup.string().required('To pole nie może być puste'),
    application: Yup.string().required('To pole nie może być puste'),
    zs_timed_periods: Yup.object().required('To pole nie może być puste'),
    periods_type: Yup.string().required('To pole nie może być puste'),
    programming_skills: Yup.string().required('To pole nie może być puste'),
    educational_predispositions: Yup.string().required('To pole nie może być puste'),
    special_skills: Yup.string().required('To pole nie może być puste'),
    description: Yup.string().required('To pole nie może być puste')
  });

  const formik = useFormik({
    initialValues: {
      employee: rowData.id,
      application: rowData.id,
      camp:
        rowData.periods_type == 'obozy' && !data.camp
          ? weekPeriod.period.id.split('-').pop()
          : data.camp || null,
      resort: rowData.periods_type == 'obozy' && !data.resort
        ? choices.review_resorts.find(item => item.label === weekPeriod.period.name.split(' ')[0].toUpperCase())?.value
        : data.resort || null,
      event: data.event || null,
      periods_type: rowData.periods_type,
      zs_timed_periods:
      rowData.periods_type == 'zielone_szkoly' && !data.zs_timed_periods
        ? cleanedZsPeriod
        : data.zs_timed_periods || null,
      programming_skills: data.programming_skills || '',
      educational_predispositions: data.educational_predispositions || '',
      special_skills: data.special_skills || '',
      description: data.description || '',
      grades: []
    },
    validateOnChange: false,
    validationSchema: rowData.periods_type == 'obozy' ? olValidationSchema : zsValidationSchema,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  React.useEffect(() => {
    // Tworzymy mapę istniejących ocen na podstawie kategorii
    const existingGradesMap = new Map(
      (data.grades || []).map(g => [g.category, g.value])
    );

    // Tworzymy pełną listę ocen
    const fullGrades = choices.grades_categories.map(item => ({
      name: item.label,
      category: item.value,
      value: existingGradesMap.has(item.value)
        ? existingGradesMap.get(item.value)
        : null
    }));

    formik.setValues({
      employee: rowData.employee,
      application: rowData.id,
      camp:
      rowData.periods_type == 'obozy' && !data.camp
        ? weekPeriod.period.id.split('-').pop()
        : data.camp || null,
      resort: rowData.periods_type == 'obozy' && !data.resort
        ? choices.review_resorts.find(item => item.label === weekPeriod.period.name.split(' ')[0].toUpperCase())?.value
        : data.resort || null,
      // resort: data.resort || null,
      event: data.event || null,
      periods_type: rowData.periods_type,
      zs_timed_periods:
      rowData.periods_type == 'zielone_szkoly' && !data.zs_timed_periods
        ? cleanedZsPeriod
        : data.zs_timed_periods || null,
      programming_skills: data.programming_skills || '',
      educational_predispositions: data.educational_predispositions || '',
      special_skills: data.special_skills || '',
      description: data.description || '',
      grades: fullGrades
    });
  }, [data]);

  const availableEvents = (choices.camp_events || []).filter(event => (
    String(event.resort) === String(formik.values.resort) &&
    event.camps.some(campId => String(campId) === String(formik.values.camp))
  ));

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{data.id ? 'Edytuj opinię' : 'Dodaj opinię'}</DialogTitle>
      <DialogContent spacing={2}>
        <Box sx={{ height: 20 }}></Box>
        <Stack spacing={2}>
          {rowData.periods_type === 'obozy' && (
            <>

              <FormControl>
                <InputLabel>Ośrodek</InputLabel>
                <Select
                  disabled
                  name="resort"
                  id="resort_field"
                  value={formik.values.resort}
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.resort)}
                  helperText={formik.errors.resort}
                  fullWidth
                >
                  {choices.review_resorts?.map(obj => (
                    <MenuItem value={obj.value} key={obj.value}>
                      {obj.label}
                    </MenuItem>
                  )) || []}
                </Select>
              </FormControl>

              {formik.values.camp && formik.values.resort && (
                <FormControl>
                  <InputLabel>Impreza</InputLabel>
                  <Select
                    disabled={isEventOptional}
                    name="event"
                    id="event_field"
                    value={formik.values.event}
                    onChange={formik.handleChange}
                    fullWidth
                    error={Boolean(formik.errors.event)}
                    helperText={formik.errors.event}
                  >
                    {availableEvents.length ? (
                      availableEvents.map(obj => (
                        <MenuItem value={obj.value} key={obj.value}>
                          {obj.label}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>Brak imprez dla wybranego turnusu</MenuItem>
                    )}
                  </Select>
                  {!formik.values.event && data.event_legacy != null && (
                    <FormHelperText>
                      Zapisana wartość (historyczna): {data.event_display}. Wybór nowej
                      imprezy z listy zastąpi tę wartość.
                    </FormHelperText>
                  )}
                </FormControl>
              )}
            </>
          )}

          {formik.values.grades.map((grade, index) => (
            <Box
              key={grade.category}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2
              }}
            >
              <Typography sx={{ minWidth: 200 }}>
                {grade.name.toLowerCase()}
              </Typography>
              <Rating
                name={`grades.${index}.value`} // Klucz Formika
                value={formik.values.grades[index]?.value || 0} // Domyślna wartość
                onChange={(event, newValue) => {
                  formik.setFieldValue(`grades.${index}.value`, newValue);
                }}
                max={6} // Ustawiamy 6-stopniową skalę
                size="large" // Opcjonalne: rozmiar gwiazdek
              />
            </Box>
          ))}
          <TextField
            name="programming_skills"
            fullWidth
            label="Umiejętności z zakresu programu"
            value={formik.values.programming_skills}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.programming_skills)}
            helperText={formik.errors.programming_skills}
          />
          <TextField
            name="educational_predispositions"
            fullWidth
            label="Predyspozycje wychowawcze"
            value={formik.values.educational_predispositions}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.educational_predispositions)}
            helperText={formik.errors.educational_predispositions}
          />
          <TextField
            name="special_skills"
            fullWidth
            label="Specjalista (umiejętności i predyspozycje)"
            value={formik.values.special_skills}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.special_skills)}
            helperText={formik.errors.special_skills}
          />
          <TextField
            name="description"
            multiline
            rows={4}
            fullWidth
            label="Dłuższy komentarz"
            value={formik.values.description}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.description)}
            helperText={formik.errors.description}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={formik.handleSubmit}
          color="primary"
          variant="contained"
        >
          Zapisz
        </Button>
      </DialogActions>
    </Dialog>
  );
};
